const ERROR_MESSAGES = {
  REQUIRED_COUNTER: 'Mohon pilih cabang.',
  REQUIRED_NEED: 'Mohon pilih keperluan.',
  REQUIRED_CODE: 'Mohon pilih code.',
  REQUIRED_PHONE: 'Mohon masukkan nomor whatsapp.',
  REQUIRED_TYPE: 'Mohon pilih tipe.',
  REQUIRED_NUMBER: 'Mohon pilih nomor.',
  REQUIRED_CUST_NO: 'Mohon masukkan nomor customer',
  REQUIRED_NAME: 'Mohon masukkan nama',
  REQUIRED_EMAIL: 'Mohon masukkan email',
  INVALID_EMAIL: 'Mohon masukkan email yang valid',
  VALID_NUMBER: 'Mohon masukkan nomor yang valid.',
  MINIMUM_10: 'Minimal 10 karakter',
  MAXIMUM_15: 'Maksimal 15 karakter',
  NO_TOKEN: 'Kendala pada Token reCaptcha',
  CUSTOMER_NOT_FOUND: 'Data customer tidak ditemukan.',
  SELECT_FIRST_QUEUE: 'Mohon pilih tiket pertama yang akan dipanggil.',
  REQUIRED_KODE_UNIK: 'Mohon masukkan kode unik.',
  REQUIRED_KTP_DIGIT: 'Mohon masukkan 3 digit terakhir KTP.',
  REQUIRED_CONSENT: 'Anda wajib menyetujui pernyataan ini.',
  REQUIRED_CANCEL_REASON: 'Mohon isi alasan pembatalan.',
  MAXIMUM_500: 'Maksimal 500 karakter',
}

const SUCCESS_MESSAGES = {
  PRINT_TICKET: 'Ticket berhasil dibuat.',
  SUCCESS_LOGIN: 'Login berhasil.',
  SUCCESS_LOGOUT: 'Anda telah logout.',
  SUCCESS_START_QUEUE: 'Sistem antrean dimulai',
  SUCCESS_STOP_QUEUE: 'Sistem antrean berhenti',
  SUCCESS_NEXT_QUEUE: 'Memanggil antrean',
  SUCCESS_SERVE_QUEUE: 'Memulai melayani antrean',
  SUCCESS_AUX_QUEUE: 'Selesai melayani antrean',
  SUCCESS_SKIP_QUEUE: 'Antrean dilewati',
  SUCCESS_CANCEL_QUEUE: 'Antrean dibatalkan',
  SUCCESS_RECALL_QUEUE: 'Memanggil antrean kembali',
  SUCCESS_MOVE_BACK_QUEUE: 'Memanggil antrean yang dilewati',
  SUCCESS_START_PREVIEW: 'Memulai layar antrean',
}

export { ERROR_MESSAGES, SUCCESS_MESSAGES }
